<template>
  <settings-button
    class="toggle"
    :class="isSession || isAccountSettings ? 'session-toggle' : ''"
    @click="$emit('toggled')"
  >
    <div class="toggle-background" :class="isEnabled ? 'special' : 'grey'">
      <div
        class="toggle-circle"
        :class="isEnabled ? 'enabled' : 'disabled'"
      ></div>
    </div>
  </settings-button>
</template>
<script>
import SettingsButton from "../BaseComponents/SettingsButton";
export default {
  name: "ToggleButton",
  components: {
    SettingsButton,
  },
  props: {
    isEnabled: Boolean,
    isSession: Boolean,
    isAccountSettings: Boolean,
  },
};
</script>
<style scoped>
.toggle {
  background-color: #e2e2e2ad;
  border-radius: 360px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 45px;
  padding: 3px;
  cursor: pointer;
}

.session-toggle {
  margin-left: auto;
}

.toggle:hover .toggle-circle {
  background-color: #f7f7f7;
}

.toggle:hover .special {
  background-color: #2b2c2d;
}

.toggle-background {
  height: 32px;
  margin: 0;
  padding: 0px 2px;
  border-radius: 360px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease-in-out;
}

.toggle-circle {
  background-color: white;
  height: 28px;
  width: 28px;
  box-sizing: border-box;
  margin: 0;
  padding: 0px;
  border-radius: 360px;
  transition: 0.2s ease-in-out;
}

.special {
  background-color: #323333;
}

.enabled {
  margin-left: auto;
}

.disabled {
  margin-right: auto;
}
</style>